export function summarizeDashboard(rows) {
  const list = Array.isArray(rows) ? rows : [];
  const models = new Set();
  const sum = { requests: 0, quota: 0, tokens: 0 };
  list.forEach((r) => {
    sum.requests += r.RequestCount || 0;
    sum.quota += r.Quota || 0;
    sum.tokens += (r.PromptTokens || 0) + (r.CompletionTokens || 0);
    if (r.ModelName) models.add(r.ModelName);
  });
  return { ...sum, models: models.size };
}
